const actionTypes = {
    GET_TABLE_RECORDS_SUCCESS: 'GET_TABLE_RECORDS_SUCCESS',
    CLEAN_API_LOGGERS: 'CLEAN_API_LOGGERS',
    ADD_API_LOGGERS: 'ADD_API_LOGGERS',
    DATA_DASHBOARD: 'DATA_DASHBOARD',
    GET_PENDING_FILE_UPLOADS: 'GET_PENDING_FILE_UPLOADS',
    GET_RECORDS_FOR_AUTHORIZATION: 'GET_RECORDS_FOR_AUTHORIZATION',
};

export default actionTypes;